import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    "total", "subCost", "balance", "surcharge", "saleTotal", "currentReturnTotal", "balText",
    "invoiceTotal", "invoicePaid", "invoiceBalance", "previousSubCost", "previousRefunded", "returnedSaleValue"
  ]

  setTotal(){
    const documentType = this.element.dataset.returnTotalDocumentType;

    let previousReturnedTotal = 0;
    let previousRefunded = 0;

    // Sum all previous returns
    if (this.hasPreviousSubCostTarget) {
      if (Array.isArray(this.previousSubCostTargets)) {
        previousReturnedTotal = this.previousSubCostTargets.reduce((total, el) => {
          return total + parseFloat(el.textContent || el.value || 0);
        }, 0);
      } else {
        previousReturnedTotal = parseFloat(this.previousSubCostTarget.textContent || this.previousSubCostTarget.value || 0);
      }
    }

    // Get total refunded for previous returns
    if (this.hasPreviousRefundedTarget) {
      previousRefunded = parseFloat(this.previousRefundedTarget.textContent.replace(/[^0-9.-]+/g,"")) || 0;
    }

    // Sum current return's sub_costs
    const currentReturnedTotal = this.hasSubCostTarget
        ? (Array.isArray(this.subCostTargets)
            ? this.subCostTargets.reduce((total, subcost) => total + parseFloat(subcost.textContent), 0)
            : parseFloat(this.subCostTarget.textContent))
        : 0;

    // Show only the current return value in the "Total Return value" field
    this.totalTarget.textContent = currentReturnedTotal;

    // Use previous + current for balance calculations
    const returnedTotal = currentReturnedTotal;

    if (documentType === "sale-receipt") {
      const saleTotal = parseFloat(this.saleTotalTarget.innerHTML);
      const surcharge = parseFloat(this.surchargeTarget.value) || 0;

      // If sale has previous returns, show remaining sale value
      if (this.hasReturnedSaleValueTarget) {
        // returnedSaleValue = saleTotal - previousReturnedTotal
        this.returnedSaleValueTarget.textContent = saleTotal - previousReturnedTotal;
      }

      // Calculate balance after all returns (previous + current)
      const balance = saleTotal - returnedTotal - surcharge;
      this.balanceTarget.textContent = balance;
    } else if (documentType === "invoice") {
      const invoicePaidTotal = parseFloat(this.invoicePaidTarget.innerHTML);
      const invoiceTotal = parseFloat(this.invoiceTotalTarget.innerHTML);
      const surcharge = parseFloat(this.surchargeTarget.value) || 0;
      const totalReturned = previousReturnedTotal + currentReturnedTotal;

      let balance;
      if (invoicePaidTotal > 0) {
        const adjustBal  = invoiceTotal  -  totalReturned;
        balance = invoicePaidTotal - adjustBal - surcharge;
        this.invoiceBalanceTarget.textContent  = balance;
      } else {
        balance = invoiceTotal - totalReturned;
        this.invoiceBalanceTarget.textContent = balance;
      }

      if (balance < 0) {
        this.balTextTarget.innerHTML = `
          <span class="text-success">
            Customer is owed a refund of <strong>${Math.abs(balance).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</strong>
          </span>
        `;
      } else if (balance > 0) {
        this.balTextTarget.innerHTML = `
          <span class="text-danger">
            Customer still owes <strong>${balance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</strong>
          </span>
        `;
      } else {
        this.balTextTarget.innerHTML = `
          <span class="text-info">
            No balance remaining.
          </span>
        `;
      }
    }
  }
}
